<template>
    <div class="Product" id="a3">
        <div class="Product-title"> {{Title}} </div>
        <div class="Product-subheading"> {{Subheading}} </div>
        <div>
            <el-row class="Product-content-bg">
                <el-col class="Product-left-bg" :span="6">
                    <div class="Product-left-bg-line-mark"></div>
                    <div class="Product-left-bg-title"> {{Items[Select].Title}} </div>
                    <div class="Product-left-bg-subheading">{{Items[Select].Subheading}}</div>
                    <div class="Product-left-bg-content-bg">
                        <div class="Product-left-bg-content" v-for="title in Items[Select].Content" :key="title"> {{title}}  </div>
                    </div>
                    <el-button class="Product-left-bg-button" @click="onDetails(Items[Select].Id)" round> 了解详情 </el-button>
                </el-col>
                <el-col :span="13">
                    <el-carousel height="442px" indicator-position="none" :arrow="Items[Select].Images.length > 1?'hover':'never'">
                        <el-carousel-item v-for="(image, index) in Items[Select].Images" :key="index + 'image'">
                            <el-image :src="image"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </el-col>
                <el-col class="Product-right-bg" :span="4">
                    <div v-for="(item, index) in Items" :key="index" @click="Select = index">
                        <button @click="Select = index" :class="ButtonStyles[Select == index? 0:1]" type="primary">
                            <div class="Product-right-bg-icon"><i :class="item.ButtonIcon"></i></div>
                            <div class="Product-right-bg-title">{{item.ButtonTitle}}</div>
                        </button>
                        <div style="height:18px"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    components:{
        //  :autofocus="index == Select"
    },
    data() {
        return {
            Select: 0,
            ButtonStyles: [
                "Product-right-bg-button1",
                "Product-right-bg-button2"
            ],
            Title: "产品系统功能",
            Subheading: "抢占流量获取和变现的下一个新风口",
            Items: [
                {
                    Id: 1,
                    ButtonTitle: "客户管理",
                    ButtonIcon: "icon-zhanghuguanli",
                    Images: [
                        require("../assets/img/home/product_khgl.png"),
                    ],
                    Title: "提效客户管理",
                    Subheading: "沉淀客户数据资产，高效管理每个客户",
                    Content: ["CRM组件：记录客户行为旅程，智能计算“互动指数”，帮你了解每个客户。",
                    "任务系统：一键下发任务，跟踪营销进程。宝来客“小秘书”帮你记住每日琐碎待办。",
                    "客户运营：自定义客户分组，精细化运营客户。"],
                },
                {
                    Id: 2,
                    ButtonTitle: "会员管理",
                    ButtonIcon: "icon-bianzu28",
                    Images: [
                        require("../assets/img/home/product_hygl.png"),
                    ],
                    Title: "生命周期营销",
                    Subheading: "实现自动化培育、智能化营销",
                    Content: ["围绕用户生命周期模型，在关键节点进行自动的策略化营销，不错过每个MOT",
                    "统计市场活动投入成本、产出，评估市场营销效果，高效驱动营销渠道ROI提升",
                    "定义营销漏斗及多维度数据报表，全面洞察营销效果，科学助力营销决策"],
                },
                {
                    Id: 3,
                    ButtonTitle: "连接微信",
                    ButtonIcon: "icon-bianzu29",
                    Images: [
                        require("../assets/img/home/product_ljwx1.png"),
                    ],
                    Title: "多触点沟通",
                    Subheading: "实连接沟通渠道，和客户建立多触点联系",
                    Content: ["企业微信：微信官方授权服务商，深度打通企业微信，赋能微信运营转化场景",
                    "微信服务号：以自有媒体和触点作为企业的流量基地，构建企业私域流量池",
                    "微信小程序：通过在一个位置跟踪客户信息和互动，更快地推进交易"],
                },
                {
                    Id: 4,
                    ButtonTitle: "活动工具",
                    ButtonIcon: "icon-bianzu8",
                    Images: [
                        require("../assets/img/home/product_hdgj1.png"),
                    ],
                    Title: "MarTech营销工具链",
                    Subheading: "在这个流量如黄金的时代，让你用更低成本获取流量",
                    Content: ["覆盖所有营销活动类型，对每一次活动的设计、执行和监控提供完整的管理",
                    "通过大规模自动化和个性化营销来提高客户参与度",
                    "通过将他们与营销、销售和服务联系起来，提供卓越的社交体验"],
                },
                {
                    Id: 5,
                    ButtonTitle: "数据分析",
                    ButtonIcon: "icon-bianzu4",
                    Images: [
                        require("../assets/img/home/product_sjfx1.png"),
                    ],
                    Title: "大数据分析",
                    Subheading: "全流程数据驱动解决方案，驱动业务决策和产品智能",
                    Content: ["对全渠道原始数据自动化加工为多维度特征，形成全域客户画像",
                    "利用最新信息，更快地随时随地做出更有洞察力的决策",
                    "市场活动线上数字化管理，全程跟进转化情况，持续提升活动效果"],
                },
            ],
        }
    },
    mounted(){

    },
    methods:{
        onDetails(id) {
            this.onBaoLaiKem();
        },
        onBaoLaiKem() {
            window.open(this.$store.state.blkUrl+"/");
        },
    }
}
</script>

<style lang="scss" scoped>
.Product {
    width: 100%;
    height: 800px;
    margin: 0 auto;
    background: #F8F9FF;
    position: relative;
    &-title {
        color: #211C39;
        padding-top: 100px;
        font-size: 34px;
        text-align: center;
        font-weight: 800;
    }
    &-subheading {
        color: #514D66;
        font-size: 20px;
        text-align: center;
        padding: 20px 0px 60px 0px;
    }
    &-content-bg {
        height: 450px !important;
        width: 1400px;
        margin: 0 auto;
    }
    &-left-bg {
        display: initial;
        &-line-mark {
            width: 52px;
            height: 6px;
            background: #7E49FE;
        }
        &-title {
            color: #211C39;
            font-size: 28px;
            padding: 24px 0px;
        }
        &-subheading {
            width: 324px;
            font-size: 18px;
            color: #514D66;
            padding-bottom: 16px;
        }
        &-content-bg {
            width: 322px;
            height: 212px;
        }
        &-content {
            width: 322px;
            font-size: 16px;
            color: #514D66;
            line-height: 30px;
            padding-bottom: 15px;
        }
        &-button {
            width: 140px;
            border: 1px solid #7E49FE;
            bottom: 0px;
            position: absolute;
        }
    }
    &-right-bg {
        margin-top: 6px;
        &-button1 {
            width: 200px;
            height: 70px;
            margin-left: 50px;
            font-size: 18px;
            background-color: #7E49FE;
            color: #fff;
            border: 0px;
            border-radius: 4px;
        }
        &-button2 {
            width: 200px;
            height: 70px;
            margin-left: 50px;
            font-size: 18px;
            background-color: #fff;
            color: #7E49FE;
            border-radius: 4px;
            border: 1px solid #D8DBF0;
        }
        &-icon {
            float: left;
            margin-left: 35px;
        }
        &-title {
            float: right;
            font-size: 18px;
            font-weight: 400;
            line-height: 18px;
            margin-right: 35px;
            margin-top: 3px;
        }
    }
}
.el-button--primary.is-plain {
    background-color: #fff;
    border-color: #F4F4F9;
}
</style>